import {
    createSlice,
    type PayloadAction
} from '@reduxjs/toolkit';

interface ApplicationState {
    isConnected: boolean
    isReady: boolean
}

export const initialState:ApplicationState = {
    isConnected: false,
    isReady: false
}

const applicationSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        setIsConnected: (state, action: PayloadAction<boolean>) => {
            state.isConnected = action.payload
        },
        ready: (state) => {
            state.isReady = true
        }
    }
})

export const {
    setIsConnected,
    ready
} = applicationSlice.actions;
export default applicationSlice.reducer